import { FC } from "react";
import { BsChevronRight } from "react-icons/bs";
import { FiArrowRight } from "react-icons/fi";
import "./cupomInput.css";
import { Input } from "../inputs/inputs";
import { CiDiscount1 } from "react-icons/ci";
import { CiCircleRemove } from "react-icons/ci";
type Props = {
  cupon: string;
  setCupon: (value: string) => void;
  calcDiscount: () => Promise<void>;
  removeDiscount: () => Promise<void>;
  hasCoupon: boolean;
};

const CupomInput: FC<Props> = ({
  cupon,
  setCupon,
  calcDiscount,
  hasCoupon,
  removeDiscount,
}) => {
  return (
    <div className="cupom-input">
      {hasCoupon ? (
        <div className="cupom-info">
          <div className="cupom-info_discount">
            <span>
              <b> Cupom: </b> {cupon}
            </span>
            <CiDiscount1 size="24px" color="#6E7586" />
          </div>
          <CiCircleRemove
            size="24px"
            color="#d7044e"
            onClick={() => removeDiscount()}
          />
        </div>
      ) : (
        <>
          <Input
            inputAttr={{
              type: "default",
            }}
            name="typeFreight"
            placeholder={`Adicione um cupom de desconto`}
            value={cupon}
            change={(value: string) => {
              setCupon(value);
            }}
          />

          <button className="" onClick={() => calcDiscount()}>
            {" "}
            <FiArrowRight size="20px" color="#6E7586" />{" "}
          </button>
        </>
      )}
    </div>
  );
};

export { CupomInput };
